module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I thank the Lord for showering me with the Light of the Spirit of Truth! Thanks to my mom and dad who gave me life. I thank my son Rosen – a gift from God to me and my greatest like-minded person and friend. Thank you to everyone who believed in my path in the spiritual dimensions and got involved in the process of publishing my novels. I will be very happy if the new edition of the novel "), _c('em', [_vm._v("8 Seconds")]), _vm._v(" becomes popular enough through Austin Macauley Publishers to attract the attention of film producers to invest in making the film.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be8e4d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0